export const LoginActionConst = {
    USER_LOGIN_REQUEST: "USER_LOGIN_REQUEST",
    USER_LOGIN_SUCC: "USER_LOGIN_SUCC",
    USER_LOGIN_FAIL: "USER_LOGIN_FAIL",
}

export const LogOutActionConst = {
    LOGOUT_ACTION_CONST: "LOGOUT_ACTION_CONST"
}

export const CurrentSideBaseStateActionConst = {
    CURRENT_SIDE_BAR_STATUS: "CURRENT_SIDE_BAR_STATUS"
}